import React from 'react';
import classnames from 'classnames';

import { FlexRow, FlexColumn } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import FormattedCurrencyContainer from '../../../../../components/formatted-currency/container';
import { useUserLimitData } from '../../hooks/use-plan-details';

import messages from './messages';
import styles from './style.module.less';

/**
 * @typedef {object} MonetaryValue
 * @property {number} value - The monetary amount
 * @property {string} code - The currency code
 */

/**
 * @param {object} props - Component props
 * @param {MonetaryValue} props.additionalUsersTotalCost - The total cost for additional users
 * @returns {React.ReactElement} The subscription card user info component
 */
export const SubscriptionCardUserInfo = ({ additionalUsersTotalCost }) => {
  const { baseSupportedUserCount, additionalUserCount, hasUnlimitedUsers } = useUserLimitData();

  return (
    <FlexColumn>
      <Text textType={TextType.H4} value={messages.users} />
      <FlexRow
        className={classnames(styles['new-info-row'], {
          [styles.unlimited]: hasUnlimitedUsers,
        })}
      >
        <Text textType={TextType.Paragraph} value={messages.includedUsers} />
        {hasUnlimitedUsers ? (
          <Text textType={TextType.Paragraph} value={messages.unlimited} />
        ) : (
          <Text textType={TextType.Paragraph} value={baseSupportedUserCount} />
        )}
      </FlexRow>
      {!hasUnlimitedUsers && (
        <FlexRow className={classnames(styles['plan-info'], styles['new-info-row'])}>
          <FlexRow className={styles['with-count']}>
            <Text textType={TextType.Paragraph} value={messages.additionalUsers} />
            <Text className={styles.count} textType={TextType.Paragraph} value={additionalUserCount} />
          </FlexRow>
          <div className={styles['plan-info-cost']}>
            <FormattedCurrencyContainer
              currencyCode={additionalUsersTotalCost.code}
              fractionDigits={2}
              value={additionalUsersTotalCost.value}
            />
          </div>
        </FlexRow>
      )}
    </FlexColumn>
  );
};
